import PubSub from "underpub-js";

var NavBarStandalone = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

NavBarStandalone.prototype.init = function(){

	this.options.$el.find('.hamburger').on('click', function() {

		PubSub.publish('NavOverlay:show');

	});

};

export default NavBarStandalone;
